import COM from './FadeIn'

export default COM
